// routesConfig.js
import React from 'react';
import Home from '../components/dashboard/Home';
import Meeting from '../components/meetings/Meeting';
import MeetingPreview from '../components/meetings/MeetingPreview';
import CompletedMeetings from '../components/meetings/CompletedMeetings';

import HelpPage from '../components/help/HelpPage';
import Administration from '../components/administration/Administration';
import AdminProtectedRoute from '../auth/admin_protected_route';
import AuthCallback from '../auth/callback';
import LoginLoader from '../auth/login';
import EstablishPage from '../auth/establish';

export const protectedRoutes = () => [
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/completed-meetings',
    element: <CompletedMeetings />,
  },
  {
    path: '/meeting',
    element: <Meeting />,
  },
  {
    path: '/meeting-preview',
    element: <MeetingPreview />,
  },
  {
    path: '/meeting/:instanceId',
    element: <Meeting />,
    extraProps: { isViewerMode: true }
    // This route automatically loads a meeting in viewer mode when accessed with an instance ID
    // Example: /meeting/abc123 will load meeting abc123 as a viewer
  },
  {
    path: '/help',
    element: <HelpPage />,
  },
  {
    path: '/administration',
    element: <AdminProtectedRoute><Administration /></AdminProtectedRoute>,
  },
  {
    path: '/administration/templates',
    element: <AdminProtectedRoute><Administration /></AdminProtectedRoute>,
  },
  {
    path: '/administration/prompts',
    element: <AdminProtectedRoute><Administration /></AdminProtectedRoute>,
  },
  {
    path: '/administration/prompts/create',
    element: <AdminProtectedRoute><Administration /></AdminProtectedRoute>,
  },
  {
    path: '/administration/prompts/edit/:promptSetId',
    element: <AdminProtectedRoute><Administration /></AdminProtectedRoute>,
  },
  {
    path: '/administration/scripts',
    element: <AdminProtectedRoute><Administration /></AdminProtectedRoute>,
  },
  {
    path: '/administration/llm-logs',
    element: <AdminProtectedRoute><Administration /></AdminProtectedRoute>,
  },
  {
    path: '/',
    element: <Home />,
  },
];

export const publicRoutes = [
  {
    path: '/callback',
    element: <AuthCallback />,
  },
  {
    path: '/login',
    element: <LoginLoader />,
  },
  {
    path: '/establish',
    element: <EstablishPage />,
  },
];
